import { Invoice } from '@/interfaces/invoice';
import { InvoiceResource, invoiceResource } from '@/resources/invoice.resource';
import { InvoiceFilters } from '../../interfaces/filters/invoiceFilters';
import { ListResponse } from '../../interfaces/list';
import { EntityModule } from './entity.module';

/**
 * Moduł faktur
 *
 * @export
 * @class InvoiceModule
 * @extends {EntityModule<Invoice, InvoiceResource>}
 */
export class InvoiceModule extends EntityModule<Invoice, InvoiceResource> {
  constructor() {
    super(invoiceResource);
    this.actions = {
      ...this.actions,

      /**
       * Pobiera listę encji
       *
       * @param context context
       * @param filters filtry listy
       */
      listWithDocument: (context: any, filters: InvoiceFilters): Promise<ListResponse<Invoice>> => {
        const preventLoader = filters?.preventLoader;
        if (preventLoader) {
          filters = { ...filters, preventLoader: undefined };
        }

        return this.resource.listWithDocument(filters, preventLoader).then(({ list, count }) => {
          context.commit('saveList', list);
          context.commit('saveCount', count);
          context.commit('saveFilters', filters);
          return { list, count };
        });
      },
      /**
       * Szukanie grup faktur
       *
       * @param context
       * @param query
       * @returns
       */
      searchGroup: (context, query: { query: { documentId: number; search: string }; preventLoader?: boolean }) => {
        if (!query.query?.search) {
          return Promise.resolve([]);
        }

        return this.resource.searchGroup(query.query, query.preventLoader);
      },

      /**
       * Pobranie grupy faktur
       *
       * @param context
       * @param query
       * @returns
       */
      getGroup: (context, query: { documentId: number; nip: string; number: string; date: Date }) => {
        return this.resource.getGroup(query);
      },

      /**
       * Zaakceptoanie faktury
       *
       * @param context
       * @param id
       * @returns
       */
      approve: (context, data: { id: number }) => {
        return this.resource.approve(data);
      },

      /**
       * Odblokowanie faktury
       *
       * @param context
       * @param id
       * @returns
       */
      unlock: (context, data: { id: number }) => {
        return this.resource.unlock(data);
      }
    };
  }
}

export default new InvoiceModule();
